import { render } from "./SharePage.vue?vue&type=template&id=444fd98d&scoped=true"
import script from "./SharePage.vue?vue&type=script&lang=js"
export * from "./SharePage.vue?vue&type=script&lang=js"

import "./SharePage.vue?vue&type=style&index=0&id=444fd98d&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444fd98d"]])

export default __exports__